import React from "react";
import PropTypes from "prop-types";
import Context from "shared/util/Context";
import _str from "shared/util/_str";

const PROFILE_MENU_LINKS = [
	{
		displayText: _str("Profile"),
		path: "/profile",
	},
	{
		displayText: _str("Bookmarks"),
		path: "/bookmarks",
	},
	{
		displayText: _str("Settings"),
		path: "/settings",
	},
	{
		displayText: _str("Sign Out"),
		path: "/logout",
	},
];

const FLAG_MOD_LINK = {
	displayText: _str("Review Photos"),
	path: "/flagmod",
};


if (Context.get("isFlagMod")) {
	PROFILE_MENU_LINKS.splice(3, 0, FLAG_MOD_LINK);
}

const ProfileMenu = ({ isOpen }) => {
	if (!isOpen) return null;

	return (
		<div className="profile-menu">
			{PROFILE_MENU_LINKS
				.map((menuLink) => (
					<a
						key={menuLink.displayText}
						href={menuLink.path}
						className="profile-menu-link"
					>
						{menuLink.displayText}
					</a>
				))
			}
		</div>
	);
};

ProfileMenu.defaultProps = {
	isOpen: false,
};

ProfileMenu.propTypes = {
	isOpen: PropTypes.bool,
};

export default ProfileMenu;



// WEBPACK FOOTER //
// ./src/shared/components/NavBar/ProfileMenu.jsx